import styled from "styled-components";

export const LoadingDiv = styled.div`
  margin: 0px 90px;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.3rem solid #dcdcdc;
  border-right: 0.3rem solid #dcdcdc;
  border-bottom: 0.3rem solid #dcdcdc;
  border-left: 0.3rem solid ${({ theme }) => theme.colors.primary};
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;

  &,
  &:after {
    border-radius: 50%;
    width: 1.7rem;
    height: 1.7rem;
  }

  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;
